import { StandardQuizQuestion } from '@/types/quizTypes';

export const PERFORMANCE_MONITORING_QUIZ: StandardQuizQuestion[] = [
  {
    id: "perf-mon-1",
    question: "What is Application Performance Monitoring (APM)?",
    options: [
      "Testing code quality",
      "Real-time monitoring of application performance and user experience",
      "Database backup",
      "Security scanning"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "APM involves monitoring and managing the performance and availability of software applications, tracking metrics like response time, error rates, and resource utilization.",
    category: "apm",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-2",
    question: "What are the 'Four Golden Signals' of monitoring?",
    options: [
      "CPU, RAM, Disk, Network",
      "Latency, Traffic, Errors, Saturation",
      "Users, Sessions, Clicks, Conversions",
      "Speed, Quality, Cost, Security"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Google's Four Golden Signals are: Latency (response time), Traffic (demand), Errors (failure rate), and Saturation (resource utilization). These provide comprehensive service health visibility.",
    category: "metrics",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-3",
    question: "What is distributed tracing?",
    options: [
      "Tracking user clicks",
      "Following requests across multiple services in a distributed system",
      "Database replication",
      "Load balancing"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Distributed tracing tracks requests as they flow through multiple microservices, showing the path, timing, and dependencies. Tools like Jaeger and Zipkin implement this.",
    category: "tracing",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-4",
    question: "What is the difference between metrics and logs?",
    options: [
      "No difference",
      "Metrics are numerical measurements, logs are detailed event records",
      "Metrics are text files",
      "Logs are always encrypted"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Metrics are aggregated numerical data (CPU%, request count) ideal for dashboards and alerts. Logs are detailed event records useful for debugging specific issues.",
    category: "observability",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-5",
    question: "What is a Service Level Indicator (SLI)?",
    options: [
      "A performance test",
      "A quantitative measure of service performance",
      "A code quality metric",
      "A security audit"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "SLIs are specific metrics that measure service performance, like availability percentage, error rate, or latency. They're used to define SLOs (Service Level Objectives).",
    category: "sli-slo",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-6",
    question: "What is synthetic monitoring?",
    options: [
      "Using AI to monitor systems",
      "Simulating user interactions to proactively test availability",
      "Monitoring artificial intelligence",
      "Fake performance data"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Synthetic monitoring uses scripted transactions to simulate user behavior, proactively testing application availability and performance before real users encounter issues.",
    category: "monitoring-types",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-7",
    question: "What is the purpose of an alert threshold?",
    options: [
      "To delete old data",
      "To trigger notifications when metrics exceed defined limits",
      "To encrypt data",
      "To compress logs"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Alert thresholds define acceptable metric ranges. When exceeded (e.g., CPU > 80%, error rate > 1%), they trigger notifications to operations teams for investigation.",
    category: "alerting",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "perf-mon-8",
    question: "What is a performance bottleneck?",
    options: [
      "A network cable",
      "A system component limiting overall performance",
      "A software license",
      "A user interface element"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "A bottleneck is the slowest component in a system that limits overall performance. Common bottlenecks include slow databases, insufficient CPU, network latency, or inefficient code.",
    category: "optimization",
    points: 10,
    type: "multiple-choice"
  }
];

export const generatePerformanceMonitoringQuiz = () => ({
  questions: PERFORMANCE_MONITORING_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'performance-monitoring'
});
